import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CatalogueActions from "./CatalogueActions";
import { EntreprisesServices } from "$services";
import { usePopin } from "$components/Popin/usePopin";
import useAuth from "$hooks/useAuth";
import { CatalogueProductForm } from "./CatalogueProductForm";
import useExport from "$hooks/useExport";
import { ImportType } from "$types/import/ImportType";
import { CacheInvalidationAction } from "$utils/cache";

export function WrapCatalogueActions({
  companyId,
  filterText,
  filterByCateg,
  filterIsActive,
  setFilterIsActive,
}: any) {
  const token = localStorage.getItem("access_token");
  const { Popin, PopinProps, togglePopin } = usePopin();
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { exportXLS } = useExport();

  const { data: company } = useQuery({
    queryKey: [CacheInvalidationAction.GET_COMPANY_BY_ID, companyId],
    queryFn: () => EntreprisesServices.FetchCompany(token, companyId),
    enabled: !!companyId,
    staleTime: 1000 * 60,
  });

  const handleExportCatalog = async (type: ImportType) => {
    setIsLoading(true);
    const categoriesFilter =
      filterByCateg?.length > 0 ? filterByCateg.split(",") : [];
    const filters = {
      company: companyId,
      textSearch: filterText,
      categories: categoriesFilter,
      isInReferenceCategory: undefined,
      isActive: filterIsActive,
    };
    if (type === ImportType.PRODUCT_UPDATE) {
      filters.isInReferenceCategory = false;
    }

    await exportXLS(token, filters, type, "Products");
    setIsLoading(false);
  };

  const handlePushCategory = useCallback(async () => {
    if (companyId && location.pathname.includes("/entreprise/")) {
      navigate(`/entreprise/${companyId}/catalogue/categories`);
    } else {
      navigate(`/catalogue/categories/${companyId}`);
    }
  }, [companyId, location.pathname, navigate]);

  if (!companyId) {
    return null;
  }

  return (
    <>
      <CatalogueActions
        company={company}
        handleExportCatalog={handleExportCatalog}
        handlePushCategory={handlePushCategory}
        toggleOpen={togglePopin}
        isLoadingExport={isLoading}
        filterIsActive={filterIsActive}
        setFilterIsActive={setFilterIsActive}
      />
      <Popin {...PopinProps}>
        {isAdmin() && (
          <CatalogueProductForm
            togglePopin={togglePopin}
            companyId={companyId}
            product={undefined}
          />
        )}
      </Popin>
    </>
  );
}
